import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  InfoChipColor,
  InfoChipIconSet,
  InfoChipShape,
  InfoChipSize,
  InfoChipToneState,
  InfoChipType,
} from './info-chip.types';

@Component({
  selector: 'app-info-chip',
  templateUrl: './info-chip.component.html',
  styleUrls: ['./info-chip.component.scss'],
})
export class InfoChipComponent {
  @Input() label: string = '';
  @Input() color: InfoChipColor = 'blue';
  @Input() type: InfoChipType = 'filled';
  @Input() size: InfoChipSize = 'large';
  @Input() shape: InfoChipShape = 'rounded-large';
  @Input() iconLeading?: string;
  @Input() iconTrailing?: string;
  @Input() iconSet: InfoChipIconSet = 'material-symbols-rounded';
  @Input() removable: boolean = false;

  @Output() onRemove = new EventEmitter<void>();

  toneState: InfoChipToneState = 'default';

  get paddingVariant(): 'none' | 'leading' | 'trailing' | 'both' {
    const hasLeading = this.type === 'outline' || !!this.iconLeading;
    const hasTrailing = (!!this.iconTrailing && !this.removable) || this.removable;
    if (hasLeading && hasTrailing) {
      return 'both';
    }
    if (hasLeading) {
      return 'leading';
    }
    if (hasTrailing) {
      return 'trailing';
    }
    return 'none';
  }

  get rootClasses(): string {
    return [
      'munily-info-chip',
      `info-chip-color-${this.color}`,
      `info-chip-type-${this.type}`,
      `info-chip-size-${this.size}`,
      `info-chip-shape-${this.shape}`,
      `info-chip-tone-${this.toneState}`,
      `info-chip-pad-${this.paddingVariant}`,
    ].join(' ');
  }

  onMouseEnter(): void {
    if (this.toneState !== 'active') {
      this.toneState = 'hover';
    }
  }

  onMouseLeave(): void {
    this.toneState = 'default';
  }

  onMouseDown(): void {
    this.toneState = 'active';
  }

  onMouseUp(): void {
    this.toneState = 'hover';
  }

  handleRemove(event: Event): void {
    event.stopPropagation();
    this.onRemove.emit();
  }
}
